import { Component } from '@angular/core';
import { AlertService } from './alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})
export class AlertComponent {

  constructor(public alertService: AlertService) { }
 onNo() {
    this.alertService.answerNo();
  }

  onYes() {
    this.alertService.answerYes();
  }

  onCurtain() {
    this.alertService.onCurtain();
  }

  onOK() {
    this.alertService.answerOK();
  }
}
